import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_22.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/worklife');
  const shareText = encodeURIComponent('Work-Life Balance Examples to Boost Employee Engagement!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Work Life Balanace — Outstanding Workplaces</title>
        <meta property="og:title" content="Work Life Balanace — Outstanding Workplaces" />
        <meta property="og:description" content="Work-Life Balance Examples to Boost Employee Engagement" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778052541/i_18_hueuhz.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/worklife" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Work Life Balanace — Outstanding Workplaces" />
        <meta name="twitter:description" content="Work-Life Balance Examples to Boost Employee Engagement" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778052541/i_18_hueuhz.jpg" />
      </Helmet>

       <div className="sight_22_page_wrapper">
        <div className="sight_22_content_container">

          <div className="sight_22_section_one">

            <h1 className="sight_22_page_title">
             At Ashley Furniture India, Innovation Meets People-First Practices to Create an Outstanding Workplace
            </h1>

            <div className="sight_22_row">

              <div className="sight_22_left">
                <div className="sight_22_image_wrapper">
                  <img src="/Ashely_main_img.png" alt="Team meeting discussion" className="sight_22_blog_image" />
                </div>

                {/* SHARE SECTION */}
                <div className="sight_22_share_section">
                  <span className="sight_22_share_text">Share :</span>
                  <div className="sight_22_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_22_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_22_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_22_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_22_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

           <div className="sight_22_para_wrapper">
                  <h2 className="sight_22_para_title">
                    In today’s rapidly evolving business environment, innovation is no longer driven by technology alone. It is driven by people—their ideas, curiosity, collaboration and willingness to challenge the way things have always been done.
                  </h2>
                  <h2 className="sight_22_para_title">
                    Ashley Furniture India is building a strong example of this philosophy through its Global Capability Center (GCC) in Chennai, where technology, innovation and people-centric practices come together to create a future-ready workplace.
                  </h2>
                   <h2 className="sight_22_para_title">
                    Established in 2022, Ashley’s Chennai GCC has grown from a single-employee operation into a technology and business hub with more than 500 professionals. Its journey reflects how a clear global vision, local talent and a strong culture can come together to create meaningful business impact.
                  </h2>
                 
                  
                </div>

              </div>

              <div className="sight_22_right">
                <div className="sight_22_ad_card">
                  <img src="/assets/bc_1.png" className="sight_22_ad_bg" />
                  <div className="sight_22_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_22_ad_badge" />

                  <div className="sight_22_ad_content">
                    <h2>
                      Earn the Outstanding <br />
                      <span>Workplaces Certification</span>
                    </h2>
                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>
                    <button
                      className="sight_22_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>

            
          </div>

          <div className="sight_22_section">
            <div className="sight_22_topics">

             

              <div className="sight_22_topic_item">
                <h3 className="sight_22_topic_heading">Building a Culture Where People and Innovation Grow Together</h3>
                <ul className="sight_22_topic_list">
                  <li>
                   At the heart of Ashley’s workplace philosophy is the belief that business growth and employee growth go hand in hand.
                  </li>
                  
                  <li>
                    The company’s culture emphasizes values such as integrity, continuous improvement, leadership, collaboration, passion and customer-centricity. These principles create an environment where employees are encouraged not only to deliver results but also to learn, experiment and contribute new ideas.
                  </li>
                  <li>
                    For a modern GCC, this approach is particularly important. Employees are working on complex technology, business and transformation initiatives that have a direct impact on global operations. Giving people the freedom to think differently helps transform the GCC from a support function into a strategic innovation engine.
                  </li>
                   
                 
                </ul>
              </div>

              <div className="sight_22_topic_item">
                <h3 className="sight_22_topic_heading">From Chennai to Global Impact</h3>
                <ul className="sight_22_topic_list">
                  <li>
                   Ashley GCC’s growth demonstrates the increasing importance of India as a source of technology, talent and innovation.
                  </li>
                   <li>
                   The Chennai center supports global business priorities across technology, operations and business functions while collaborating closely with Ashley’s international teams. This global-local connection enables Indian professionals to work on challenges that influence customers, employees and business operations across markets.
                  </li>
                  <li>
                    The result is a workplace where employees can see the broader impact of their contributions.
                  </li>
                                    
                </ul>
              </div>

              <div className="sight_22_topic_item">
                <h3 className="sight_22_topic_heading">AI and Technology as Enablers of People</h3>
                <ul className="sight_22_topic_list">
      
                  <li>
                  Technology is deeply embedded in Ashley’s transformation journey. The organization has invested in artificial intelligence and digital capabilities as part of its broader transformation agenda.
                  </li>
                  
                  <li>
                  But technology alone does not create transformation.
                  </li>
                  <li>
                    The real differentiator is how people use technology to solve problems, improve processes and create better experiences.
                  </li>
                  <li>
                    Initiatives such as AI-focused learning and engagement, including collaboration around AI with IIT Madras, demonstrate how Ashley is encouraging employees to build future-ready capabilities.
                  </li>
                  <li>
                    This creates an important workplace principle: AI should not simply automate work; it should enable people to do more meaningful, creative and higher-value work.
                  </li>
                   
                  
                </ul>
              </div>
              
<div className="sight_22_topic_item">
  <h3 className="sight_22_topic_heading">
    Inclusion, Collaboration and Accessibility
  </h3>

  <ul className="sight_22_topic_list">
    <li>
      A people-first workplace is built on trust.
    </li>

    <li>
      Ashley GCC’s culture places emphasis on transparency, inclusion,
      collaboration and accessible leadership.
    </li>

    <li>
      When employees feel comfortable sharing ideas, asking questions and
      expressing different perspectives, organizations become more adaptable.
    </li>

    <li>
      For growing GCCs, this is particularly valuable. Diverse teams bring
      different experiences and approaches to problem-solving, helping
      organizations build better solutions for complex global challenges.
    </li>
  </ul>
</div>

<div className="sight_22_topic_item">
  <h3 className="sight_22_topic_heading">
    Investing in the Future Beyond the Workplace
  </h3>

  <ul className="sight_22_topic_list">
    <li>
      Ashley’s people-first approach also extends beyond its employees.
    </li>

    <li>
      Through STEM and AI-focused community initiatives, the organization is
      contributing to education and future talent development, including
      programs aimed at students in Grades 6–10.
    </li>

    <li>
      This reflects a broader understanding of workplace responsibility:
      organizations can contribute not only to today’s workforce but also to
      developing the talent and skills required for tomorrow.
    </li>
  </ul>
</div>

<div className="sight_22_topic_item">
  <h3 className="sight_22_topic_heading">
    Creating a Workplace Where People Belong
  </h3>

  <ul className="sight_22_topic_list">
    <li>
      An outstanding workplace is not defined only by its office, technology
      or business performance.
    </li>

    <li>
      It is defined by how people experience the organization.
    </li>

    <li>
      Do employees feel trusted?
    </li>

    <li>
      Do they have opportunities to learn?
    </li>

    <li>
      Can they contribute ideas?
    </li>

    <li>
      Are leaders accessible?
    </li>

    <li>
      Can they see a future for themselves within the organization?
    </li>

    <li>
      These questions are increasingly important as organizations compete for
      skilled talent.
    </li>

    <li>
      Ashley Furniture India’s journey demonstrates how a strong culture can
      become a strategic advantage.
    </li>

    <li>
      By combining technology, continuous learning, inclusive practices,
      leadership accessibility and employee development, Ashley GCC is creating
      an environment where people can contribute to global innovation while
      building their own careers.
    </li>
  </ul>
</div>

<div className="sight_22_topic_item">
  <h3 className="sight_22_topic_heading">
    The Future Is People + Innovation
  </h3>

  <ul className="sight_22_topic_list">
    <li>
      Ashley Furniture India’s story offers an important lesson for modern
      organizations: innovation and people-first culture are not competing
      priorities—they strengthen each other.
    </li>

    <li>
      Technology can provide the tools.
    </li>

    <li>
      Strategy can provide the direction.
    </li>

    <li>
      But people provide the creativity, judgment and energy required to turn
      ideas into impact.
    </li>

    <li>
      From its beginnings in Chennai to its evolution as a growing global
      capability hub, Ashley Furniture India demonstrates what can happen when
      organizations invest simultaneously in technology and people.
    </li>

    <li>
      Because the most outstanding workplaces are not simply places where
      people work. They are places where people learn, innovate, belong and
      grow.
    </li>
  </ul>
</div>







             
             

              

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;